var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex-center-column home-mcn" }, [
      _c("div", { staticClass: "title-zh" }, [_vm._v("MCN机构")]),
      _c("div", { staticClass: "title-en" }, [
        _vm._v("他们已入驻火乐园，也非常期待您的加入"),
      ]),
      _c("div", { staticClass: "flex-row-h-center mcn-list" }, [
        _c("div", { staticClass: "flex-column-center mcn-item" }, [
          _c("img", {
            attrs: { src: require("@/assets/home/logo1.png"), alt: "" },
          }),
          _c("span", { staticClass: "dec" }, [_vm._v("铭瀚国际")]),
        ]),
        _c("div", { staticClass: "flex-center-column mcn-item" }, [
          _c("img", {
            attrs: { src: require("@/assets/home/logo1.png"), alt: "" },
          }),
          _c("span", { staticClass: "dec" }, [_vm._v("铭瀚国际")]),
        ]),
        _c("div", { staticClass: "flex-center-column mcn-item" }, [
          _c("img", {
            attrs: { src: require("@/assets/home/logo1.png"), alt: "" },
          }),
          _c("span", { staticClass: "dec" }, [_vm._v("铭瀚国际")]),
        ]),
        _c("div", { staticClass: "flex-center-column mcn-item" }, [
          _c("img", {
            attrs: { src: require("@/assets/home/logo1.png"), alt: "" },
          }),
          _c("span", { staticClass: "dec" }, [_vm._v("铭瀚国际")]),
        ]),
        _c("div", { staticClass: "flex-center-column mcn-item" }, [
          _c("img", {
            attrs: { src: require("@/assets/home/logo1.png"), alt: "" },
          }),
          _c("span", { staticClass: "dec" }, [_vm._v("铭瀚国际")]),
        ]),
        _c("div", { staticClass: "flex-center-column mcn-item" }, [
          _c("img", {
            attrs: { src: require("@/assets/home/logo1.png"), alt: "" },
          }),
          _c("span", { staticClass: "dec" }, [_vm._v("铭瀚国际")]),
        ]),
        _c("div", { staticClass: "flex-center-column mcn-item" }, [
          _c("img", {
            attrs: { src: require("@/assets/home/logo1.png"), alt: "" },
          }),
          _c("span", { staticClass: "dec" }, [_vm._v("铭瀚国际")]),
        ]),
        _c("div", { staticClass: "flex-center-column mcn-item" }, [
          _c("img", {
            attrs: { src: require("@/assets/home/logo1.png"), alt: "" },
          }),
          _c("span", { staticClass: "dec" }, [_vm._v("铭瀚国际")]),
        ]),
        _c("div", { staticClass: "flex-center-column mcn-item" }, [
          _c("img", {
            attrs: { src: require("@/assets/home/logo1.png"), alt: "" },
          }),
          _c("span", { staticClass: "dec" }, [_vm._v("铭瀚国际")]),
        ]),
        _c("div", { staticClass: "flex-center-column mcn-item" }, [
          _c("img", {
            attrs: { src: require("@/assets/home/logo1.png"), alt: "" },
          }),
          _c("span", { staticClass: "dec" }, [_vm._v("铭瀚国际")]),
        ]),
        _c("div", { staticClass: "flex-center-column mcn-item" }, [
          _c("img", {
            attrs: { src: require("@/assets/home/logo1.png"), alt: "" },
          }),
          _c("span", { staticClass: "dec" }, [_vm._v("铭瀚国际")]),
        ]),
        _c("div", { staticClass: "flex-center-column mcn-item" }, [
          _c("img", {
            attrs: { src: require("@/assets/home/logo1.png"), alt: "" },
          }),
          _c("span", { staticClass: "dec" }, [_vm._v("铭瀚国际")]),
        ]),
        _c("div", { staticClass: "flex-center-column mcn-item" }, [
          _c("img", {
            attrs: { src: require("@/assets/home/logo1.png"), alt: "" },
          }),
          _c("span", { staticClass: "dec" }, [_vm._v("铭瀚国际")]),
        ]),
        _c("div", { staticClass: "flex-center-column mcn-item" }, [
          _c("img", {
            attrs: { src: require("@/assets/home/logo1.png"), alt: "" },
          }),
          _c("span", { staticClass: "dec" }, [_vm._v("铭瀚国际")]),
        ]),
        _c("div", { staticClass: "flex-center-column mcn-item" }, [
          _c("img", {
            attrs: { src: require("@/assets/home/logo1.png"), alt: "" },
          }),
          _c("span", { staticClass: "dec" }, [_vm._v("铭瀚国际")]),
        ]),
        _c("div", { staticClass: "flex-center-column mcn-item" }, [
          _c("img", {
            attrs: { src: require("@/assets/home/logo1.png"), alt: "" },
          }),
          _c("span", { staticClass: "dec" }, [_vm._v("铭瀚国际")]),
        ]),
        _c("div", { staticClass: "flex-center-column mcn-item" }, [
          _c("img", {
            attrs: { src: require("@/assets/home/logo1.png"), alt: "" },
          }),
          _c("span", { staticClass: "dec" }, [_vm._v("铭瀚国际")]),
        ]),
        _c("div", { staticClass: "flex-center-column mcn-item" }, [
          _c("img", {
            attrs: { src: require("@/assets/home/logo1.png"), alt: "" },
          }),
          _c("span", { staticClass: "dec" }, [_vm._v("铭瀚国际")]),
        ]),
        _c("div", { staticClass: "flex-center-column mcn-item" }, [
          _c("img", {
            attrs: { src: require("@/assets/home/logo1.png"), alt: "" },
          }),
          _c("span", { staticClass: "dec" }, [_vm._v("铭瀚国际")]),
        ]),
        _c("div", { staticClass: "flex-center-column mcn-item" }, [
          _c("img", {
            attrs: { src: require("@/assets/home/logo1.png"), alt: "" },
          }),
          _c("span", { staticClass: "dec" }, [_vm._v("铭瀚国际")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }